import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { AuthenticationModule } from '../authentication/authentication.module';
import { RobotCreationFormComponent } from './components/robot-creation-form/robot-creation-form.component';
import { RobotCreationSentenceInputComponent } from './components/robot-creation-sentence-input/robot-creation-sentence-input.component';
import { RobotCreationWordInputComponent } from './components/robot-creation-word-input/robot-creation-word-input.component';
import { RobotLandmarkFormComponent } from './components/robot-landmark-form/robot-landmark-form.component';
import { ClassificationModule } from '../classification/classification.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RobotTableColumnFormComponent } from './components/robot-table-form/robot-table-form.component';
import { FilterExistingRobotsPipe } from './pipes/filter-existing-robots.pipe';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { RobotCreationWordInputDatatypesComponent } from './components/robot-creation-word-input-datatypes/robot-creation-word-input-datatypes.component';

@NgModule({
  declarations: [
    RobotCreationFormComponent,
    RobotCreationSentenceInputComponent,
    RobotCreationWordInputComponent,
    RobotLandmarkFormComponent,
    RobotTableColumnFormComponent,
    FilterExistingRobotsPipe,
    RobotCreationWordInputDatatypesComponent,
  ],
  imports: [ClassificationModule, SharedModule, AuthenticationModule, FontAwesomeModule, CodemirrorModule],
  exports: [
    ClassificationModule,
    SharedModule,
    FontAwesomeModule,
    CodemirrorModule,
    RobotCreationFormComponent,
    RobotCreationSentenceInputComponent,
    RobotCreationWordInputComponent,
    RobotLandmarkFormComponent,
    RobotTableColumnFormComponent,
    FilterExistingRobotsPipe,
  ],
})
export class RobotsSharedModule { }
